import { render, staticRenderFns } from "./Race.vue?vue&type=template&id=3416344a&scoped=true&"
import script from "./Race.vue?vue&type=script&lang=js&"
export * from "./Race.vue?vue&type=script&lang=js&"
import style0 from "./Race.vue?vue&type=style&index=0&id=3416344a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3416344a",
  null
  
)

export default component.exports